/* This page is called by <ManagePhotos />
 * <ManageClassPatches />
 *    <MySelect />
 *    <AddClassPatch />
 *    <SnackBar />
 *    <ShowClassPatchesToManage />
 *    <EditClassPatch />
*/
import React, { useEffect, useState }                          from 'react'
import AddClassPatch                                           from '../Components/AddClassPatch'
import AddPhotoFieldsComponent                                 from '../Components/AddPhotoFieldsComponent'
import axios                                                   from 'axios'
import Box                                                     from '@material-ui/core/Box'
import ClassDropdown                                           from '../Components/ClassDropdown'
import Container                                               from '@material-ui/core/Container'
import EditClassPatch                                          from '../Components/EditClassPatch'
import { getTPSClassesFromNodeServer, node_server }            from '../Helpers'
import Grid                                                    from '@material-ui/core/Grid'
import { Redirect }                                            from 'react-router-dom'
import ShowClassPatchesToManage                                from '../Components/ShowClassPatchesToManage'
import SnackBar                                                from '../Atoms/SnackBar'
import Typography                                              from '@material-ui/core/Typography'

const ManageClassPatches = () => {

   const [ activateChildButton,           setActivateChildButton           ]  =  useState(true)
   const [ redirectToPhotoSearch,         setRedirectToPhotoSearch         ]  =  useState(false)

   /* Item 1. Get list of TPS Classes from MySQL DB */
   const [ tpsClasses,                    setTpsClasses                    ]  =  useState([])

   /* Item 2. TPS class selected via <MySelect /> */
   const [ tpsClass,                      setTpsClass                      ]  =  useState('')

   /* Item 3. Get classPatch from MongoDB */
   const [ classPatch,                    setClassPatch                    ]  =  useState({})

   /* If a classPatch exists, display patch */
   const [ showClassPatch,                setShowClassPatch                ]  =  useState(false)
   /* Fetches data from the DB again */
   const [ fetchClassPatch,               setFetchClassPatch               ]  =  useState(false)

   const [ patchIdToEdit,                 setPatchIdToEdit                 ]  =  useState('')
   const [ patchToEdit,                   setPatchToEdit                   ]  =  useState('')
   const [ showAddPatch,                  setShowAddPatch                  ]  =  useState(false)
   const [ showAddPhotoFieldsComponent,   setShowAddPhotoFieldsComponent   ]  =  useState(false)
   const [ snackBarMsg,                   setSnackBarMsg                   ]  =  useState('')
   const [ snackBarOpen,                  setSnackBarOpen                  ]  =  useState(false)
   const [ snackBarType,                  setSnackBarType                  ]  =  useState('')
   const [ showEditPatch,                 setShowEditPatch                 ]  =  useState(false)

   /* 
   * Item 1.
   * This used to call the PHP server and gets a list of all the TPS Classes from tbl_class_page.
   * It now calls the Noder Server and does the same thing.
   */
   useEffect( () => {
      getTPSClassesFromNodeServer()
         .then( classes => setTpsClasses(classes) )
         .catch( (error) => {
            console.error(error)
         } )
   }, [] )

   /* 
   * Item 2.
   * Sent down to <ClassDropdown /> which sends back a String containing the selected TPS Class
   */
   const getSelectedClass = (e) => {
      setTpsClass(e)
      setShowAddPatch(true)
      setShowAddPhotoFieldsComponent(true)
   }

   /* 
   * Item 3.
   * Take TPS Class from <MySelect /> and checks the MongoDB to see if an entry exists or not
   */
   useEffect( () => {
      if( tpsClass !== '' ){
         axios.get(node_server + `classPatch/GetClassPatch/${tpsClass}`)
            .then( res => res.data )
            .then( data => {
               if( data ){
                  setClassPatch( data )
                  setShowClassPatch(true)
               }
            } )
      }
   }, [tpsClass] )

   /*
   * Item 4.
   * Takes updated classPatch from <AddClassPatch /> and puts it in local state
   */
   const addClassPatchToLocalState = (classWithPatchAdded) => {
      setActivateChildButton(true)
      setClassPatch(classWithPatchAdded)
      setShowClassPatch(true)
   }

   // Updates the classPatch in MongoDB
   const updateClassPatch = () => {
      axios.put(node_server + 'classPatch/UpdateClassPatch', {
         classPatch
      })
         .then( res => res.data )
         .then( data => {
               setClassPatch(data)
               setFetchClassPatch( !fetchClassPatch )
         })
      setShowAddPatch(true)
      setShowAddPhotoFieldsComponent(true)
   }

   // Sent to <ShowClassPhotoToManage /> to get id of photo to edit
   const getPatchIdToEdit = (id) => {
      setPatchIdToEdit(id)
      if (classPatch._id === id) {
         setPatchToEdit(classPatch)
      }
      else {
         setPatchToEdit(null)
      }
      /* This removes <ShowClassPatchToManage while EDIT is being performed */
      setShowClassPatch(false)
      /* This shows or hides <AddClassPatch /> and <EditClassPhoto /> */
      setShowEditPatch(true)
      setShowAddPatch(false)
      setShowAddPhotoFieldsComponent(false)
   }

   /* Send down to <EditClassPatch />, will send back updated data */
   const updatedDataForDB = (d) => {
      if (classPatch._id === patchIdToEdit) {
         classPatch.classPatchFilename = d.filename
         setClassPatch(classPatch)
      }
      else {
         setClassPatch(null)
      }
      updateClassPatch()
      setActivateChildButton(true)
      setShowEditPatch(false)
      setShowClassPatch(true)
      return null
   }

   const handleSnackBar = ({msg, type}) => {
      setSnackBarMsg(msg)
      setSnackBarType(type)
      setSnackBarOpen(true)
      setTimeout(() => {
         setSnackBarMsg('')
         setSnackBarType('')
         setSnackBarOpen(false)
         setRedirectToPhotoSearch(true)
     }, 2500)
   }

   return (
      <Box style={{marginTop: '6rem'}} >

         { redirectToPhotoSearch ? <Redirect to='/PhotoSearch' /> : null }

         <Typography variant='h4' >
               Manage Class Patches
         </Typography>

         <Container>
               <ClassDropdown tpsClasses={tpsClasses} getSelectedClass={getSelectedClass} />
         </Container>

         {showAddPatch ? <AddClassPatch addClassPatchToLocalState={addClassPatchToLocalState} classPatch={classPatch} tpsClass={tpsClass} /> : null}

         {showClassPatch ? <ShowClassPatchesToManage classPatch={classPatch} getPatchIdToEdit={getPatchIdToEdit} /> : null}

         {showEditPatch ? <EditClassPatch patchToEdit={patchToEdit} updatedDataForDB={updatedDataForDB} /> : null}
         
         {snackBarOpen
            ?
               <Grid container justifyContent="center" style={{ marginTop: "2rem" }}>
                  <Grid item sm={6}>
                        <SnackBar msg={snackBarMsg} type={snackBarType} />
                  </Grid>
               </Grid>
            :
            null
         }
         {showAddPhotoFieldsComponent
            ?
               <AddPhotoFieldsComponent
                  activateChildButton={activateChildButton}
                  handleSnackBar={handleSnackBar}
                  title={'Class Patches - Add Photo Page'}
               />
            :
               null
         }

      </Box>
   )
}

export default ManageClassPatches
